import React from "react";
import { Results, withSearch } from "@elastic/react-search-ui";
import { getConfig } from "../../../config/faq-config-helper";
import { markMatchedWords } from "../../../../helpers/view-helpers";
import { useTranslation } from "react-i18next";

const ListItem =  ({
  result,
  onClickLink,
  titleField,
  urlField,
  thumbnailField,
  searchTerm,
  ...rest
}) => {
  const questionHtml = markMatchedWords(searchTerm, result.field_faq_question.raw);
  const answerHtml = markMatchedWords(searchTerm, result.field_faq_answer.raw);
  return (
    <div className="p-list__each">
      <dl>
        <dt className="p-list__q">
          <a className="" href={result[urlField].raw}>
            <span className="icon">Q</span>
            <div
              className=""
              dangerouslySetInnerHTML={{
                __html: questionHtml
              }}
            ></div>
          </a>
        </dt>
        <dd className="p-list__a">
          <span className="icon">A</span>
          <div
            className=""
            dangerouslySetInnerHTML={{
              __html: answerHtml
            }}
          ></div>
        </dd>
      </dl>
    </div>
  );
};

const ListItemFn = (props) => <ListItem {...props}/>
const OmronResults = ({ results, isLoading, searchTerm }) => {
  const hideNoResult = results.length > 0;
  const { t } = useTranslation();

  return (
    <div className="p-list">
      <Results
        searchTerm={searchTerm}
        resultView={(props) => ListItemFn({...props, searchTerm})}
        titleField={getConfig().faqTitleField}
        urlField={getConfig().urlField}
      />

      {!hideNoResult && !isLoading &&
        t(
          "The page you are looking for could not be found. Please try a different keyword."
        )}
    </div>
  );
};

export default withSearch(({ results, isLoading, searchTerm }) => ({ results, isLoading, searchTerm }))(OmronResults);
